import { fetch, useClient } from 'villus'

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig()

  const client = useClient({
    url: `${runtimeConfig.public.GRAPHQL_API_URL}/public`,
    use: [fetch()],
  })

  nuxtApp.vueApp.use(client)
})
